import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

const MobileMenu = ({ isOpen, navLinks, currentPath }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        className="xl:hidden bg-white border-t border-[#E5E0D8]"
        data-testid="mobile-menu"
      >
        <div className="px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 text-sm font-medium tracking-wide uppercase transition-colors border-b border-[#fafaf9] ${
                currentPath === link.path
                  ? 'text-[#0B2A57]'
                  : 'text-[#6B7280]'
              }`}
              data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.name}
            </Link>
          ))}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default MobileMenu;
